export default __webpack_public_path__ + "static/media/TheShadowOfThePyramidMap.eb8449f8.jpg";